import { Pipe, PipeTransform } from '@angular/core'
import * as moment from 'moment'

@Pipe({
  name: 'momentDateFormat'
})
export class MomentDateFormat implements PipeTransform {
  public transform(value: Date | moment.Moment, dateFormat: string): string {
    const date = moment(value)

    if (date.isValid()) {
      return moment(value).format(dateFormat)
    } else {
      return 'Invalid date'
    }
  }
}
